export default __webpack_public_path__ + "static/lushsc-2348a752ae53ab103204df2da444b706.png";